import { useRecoilValue } from 'recoil';
import { DoseMatrix } from '~/domain/patient/doseMatrix';
import useSelectedPatient from '~/hooks/patient/useSelectedPatient';
import { currentStructureSetState } from '~/state/atoms/structureSet/structureSetAtoms';

export function useReferenceDose(): DoseMatrix | undefined {
    const patient = useSelectedPatient();
    const currentStructureSet = useRecoilValue(currentStructureSetState);

    if (!patient || !currentStructureSet) {
        return undefined;
    }
    return patient.doses.find(
        (dose) => dose.structureSet?.dicomUid === currentStructureSet.dicomUid
    );
}
